module.exports = __webpack_public_path__ + "static/media/planetz1.2f01271a.png";